// components/Typography/variants.jsx
export default {
  // 52px 700
  admin_h1: "text-[40px] md:text-[46px] lg:text-[52px] text-admin_text leading-tight font-bold",

  // 36px 700
  admin_h2: "text-[28px] md:text-[32px] lg:text-[36px] text-admin_text leading-tight font-bold",

  // 28px 700,
  admin_h3: "text-[22px] md:text-[24px] lg:text-[28px] text-admin_text leading-tight font-bold",

  //22 px 700
  admin_h4: "text-[18px] lg:text-[22px] text-admin_text leading-tight font-bold",

  // 16px 600
  admin_label: "text-[16px] text-admin_text leading-normal font-semibold mt-0 mb-2",

  // 16px 600
  admin_label_dim: "text-[16px] text-admin_text_secondary leading-normal font-semibold mt-0 mb-2",

  // 12px 400 gray
  admin_label_sm_dim: "text-[12px] text-admin_text_secondary leading-tight font-normal mt-0 mb-0.5",

  // 12px 400
  admin_label_upper_dim: "text-[12px] text-admin_text_secondary font-normal uppercase tracking-wide leading-tight mt-0 mb-1",

  // 16px 400
  admin_body1: "text-[16px] text-admin_text leading-normal font-normal",

  // 16px 400 gray
  admin_body1_dim: "text-[16px] text-admin_text_secondary leading-normal font-normal",

  // 16px 700
  admin_body1_accent: "text-[16px] text-admin_text leading-normal font-bold",

  // 20px 700, color is defined per case
  admin_btn1: "text-[17px] lg:text-[20px] leading-tight font-bold",

  // 20px 700
  admin_btn2: "text-[17px] lg:text-[22px] leading-tight font-bold",

  // 15px 400
  admin_txt: "text-[15px] text-admin_text leading-tight font-normal",

  // 15px 700
  admin_txt_accent: "text-[15px] text-admin_text leading-tight font-bold",

  // 15px 400 gray
  admin_txt_dim: "text-[15px] text-admin_text_secondary leading-tight font-normal",

  // 14px 400 
  admin_txt1: "text-[14px] text-admin_text leading-tight font-normal",

  // 14px 700
  admin_txt1_accent: "text-[14px] text-admin_text leading-tight font-bold",

  // 14px 400 gray
  admin_txt1_dim: "text-[14px] text-admin_text_secondary leading-tight font-normal",

  // 12px 400
  admin_txt2: "text-[12px] text-admin_text leading-tight font-normal",

  // 12px 700 
  admin_txt2_accent: "text-[12px] text-admin_text leading-tight font-bold",

  // 12px 400 gray
  admin_txt2_dim: "text-[12px] text-admin_text_secondary leading-tight font-normal",

  // 17px 400
  admin_menu: "text-[15px] lg:text-[17px] leading-tight font-normal text-admin_text",

  // error
  admin_error: "text-[14px] text-admin_error leading-tight font-normal",

  // Default variants for the client website (overwritten per project)

  // 76px 600
  title: "text-4xl md:text-[54px] lg:text-[62px] xl:text-[70px] text-text leading-none tracking-tight font-extrabold",

  // 52px 900
  h1: "text-4xl md:text-5xl lg:text-[56px] text-text leading-none tracking-tight font-black",

  // 36px 700
  h2: "text-[28px] md:text-[32px] lg:text-[36px] text-text leading-tight tracking-tight font-bold",

  // 28px 700
  h3: "text-[22px] md:text-[24px] lg:text-[28px] text-text leading-tight tracking-tight font-bold",

  //22 px 700
  h4: "text-[18px] lg:text-[22px] text-text leading-tight tracking-tight font-bold",

  // 20px 400
  body1: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-normal",

  // 20px 400 gray
  body1_dim: "text-[16px] md:text-[17px] lg:text-[20px] text-text_secondary leading-normal font-normal",

  // 20px 500
  body1_medium: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-semibold",

  // 20px 700
  body1_accent: "text-[16px] md:text-[17px] lg:text-[20px] text-text leading-normal font-bold",

  // 16px 400 text color is defined per case 
  txt: "text-[15px] md:text-[16px] leading-tight font-normal",

  // 16px 600 text color is defined per case 
  txt_accent: "text-[15px] md:text-[16px] leading-tight font-semibold",

  // 16px 400 gray
  txt_dim: "text-[15px] md:text-[16px] text-text_secondary leading-tight font-normal",

  // 14px 400 text color is defined per case 
  txt1: "text-[14px] leading-tight font-normal",

  // 14px 600 text color is defined per case 
  txt1_accent: "text-[14px] leading-tight font-semibold",

  // 14px 400 gray
  txt1_dim: "text-[14px] text-text_secondary leading-tight font-normal",

  // 12px 400 text color is defined per case 
  txt2: "text-[12px] leading-tight font-normal",

  // 12px 600 text color is defined per case 
  txt2_accent: "text-[12px] leading-tight font-semibold",

  // 12px 400 gray
  txt2_dim: "text-[12px] text-text_secondary leading-tight font-normal",

  // 14px 400 text color is defined per case 
  label: "text-[14px] leading-tight font-normal mt-0 mb-1.5",

  // 14px 600 text color is defined per case 
  label_accent: "text-[14px] text-text leading-tight font-semibold mt-0 mb-1.5",

  // 14px 400 text color is defined per case 
  label_dim: "text-[14px] text-text_secondary leading-tight font-normal mt-0 mb-1.5",

  // 14px 400 uppercase primary color 
  label_upper_primary: "text-[14px] text-primary text-center font-bold uppercase tracking-widest mt-0 mb-2",

  label_upper_dim: "text-[12px] text-text_secondary font-normal uppercase tracking-wide leading-tight mt-0 mb-1",

  // 14px 400
  footer_item: "text-sm text-neutral_2 hover:text-white whitespace-nowrap transition-colors my-0",

  footer_group_label: "text-[10px] lg:text-[12px] font-medium uppercase tracking-wide md:tracking-widest text-neutral_1 my-0",

  // 17px 400 gray / primary
  breadcrumbs: "text-[16px] lg:text-[17px] leading-tight font-normal text-text_secondary hover:text-primary my-0",

  // error
  error: "text-[14px] text-red-500 leading-tight font-normal",


  

  // Store checkout flow defaults (ported from the aqua purchase flow)
  subtitle_32_accent: "text-[16px] md:text-[26px] lg:text-[28px] xl:text-[32px] leading-tight tracking-custom_1 font-bold",
  body_24_accent: "text-[16px] md:text-[18px] lg:text-[20px] xl:text-[24px] leading-normal tracking-custom_1 font-bold",
  body_22_accent: "text-[16px] md:text-[18px] lg:text-[20px] xl:text-[22px] leading-normal tracking-custom_1 font-bold",
  body_20: "text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] leading-normal tracking-custom_1 font-normal",
  body_20_accent: "text-[14px] md:text-[16px] lg:text-[18px] xl:text-[20px] leading-normal tracking-custom_1 font-bold",
  body_16: "text-[14px] md:text-[16px] leading-normal tracking-custom_1 font-normal",
  info_18: "text-[16px] md:text-[18px] leading-normal tracking-custom_1 font-normal",
  info_18_accent: "text-[16px] md:text-[18px] leading-normal tracking-custom_1 font-bold",
  info_16: "text-[12px] md:text-[14px] lg:text-[16px] leading-normal tracking-custom_1 font-normal",
  info_16_accent: "text-[12px] md:text-[14px] lg:text-[16px] leading-normal tracking-custom_1 font-bold text-text",
  info_14: "text-[14px] leading-normal font-normal tracking-custom_1 text-text",
}
